import styled from 'styled-components';

import { ReactComponent as CalendarIcon } from 'src/assets/calendar-icon.svg';

export const FooterContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  padding-bottom: 2.5rem;
  flex-direction: column;
  justify-content: flex-end;
`;

// Texts
export const Text = styled.p`
  font-size: 14px;
`;

export const CenterText = styled(Text)`
  text-align: center;
  margin-bottom: 20px;

  font-weight: 500;
`;

export const Link = styled.a`
  color: black;
  font-size: 14px;
`;

export const FormTitle = styled.h3`
  text-transform: uppercase;
  margin: 0;
  text-align: center;
`;

export const FooterText = styled(Text)`
  font-size: 12px;
  font-weight: 400;
`;

// Inputs
export const ResetPasswordWrapper = styled.div`
  width: fit-content;
  margin: 0 auto;
`;

export const LoginInput = styled.div`
  display: flex;
  height: 30px;
  align-items: center;
  align-self: center;
  width: 400px;
`;

export const ModalInput = styled(LoginInput)`
  position: relative;
  display: flex;
  align-items: center;
  height: 44px;
  width: 400px;
`;

export const InputLabel = styled.label`
  display: block;
  margin-bottom: 11px;
`;

export const InputIcon = styled.img`
  height: auto;
  width: 24px;
`;

export const EmailIcon = styled(InputIcon)`
  position: absolute;
  width: 18px;
  left: 16px;
`;

export const QuestionIcon = styled(InputIcon)`
  width: 22px;
  cursor: pointer;
`;

export const CloseIcon = styled(QuestionIcon)`
  width: 14px;
  align-self: flex-end;
`;

export const Input = styled.input`
  max-width: 100%;
  height: 100%;
  width: 100%;
  padding: 0 80px 0 42px;
  font-weight: bold;
  border: 1px solid #c9cbd3;
  border-radius: 4px;
  &::placeholder {
    color: #9399b2;
    font-weight: 400;
  }
`;

export const QuestionInput = styled(Input)`
  padding-left: 8px;
  margin-bottom: 12px;
`;

export const StyledErrorWrap = styled.p`
  margin: 0;
  font-size: 14px;
  color: red;
`;

export const IconWrapper = styled.div`
  height: auto;
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

export const InputCalendarContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const CustomDateInput = styled.input`
  font-family: Biotif, sans-serif;
  padding-right: 30px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px 12px;
  width: 100%;

  &::-webkit-calendar-picker-indicator {
    display: none;
  }

  &::placeholder {
    color: #999;
  }
`;

export const StyledCalendarIcon = styled(CalendarIcon)`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #888;
  pointer-events: none;
`;
